export interface NFCeData {
  accessKey: string | null;  // 44 dígitos
  uf: string | null;         // ex: 'SP'
  url: string;               // URL completa do QR Code
}

/**
 * Extrai metadados do texto do QR Code de uma NFC-e brasileira.
 * 
 * Formato v2: ?p=CHAVE|2|AMBIENTE|CSC_ID|HASH
 * Formato v3: ?p=CHAVE|3|AMBIENTE  (sem CSC e hash — NT 2025.001)
 * Formato alt: ?chNFe=CHAVE
 */
export function parseNFCeQRCode(qrText: string): NFCeData {
  const result: NFCeData = { accessKey: null, uf: null, url: qrText };
  try {
    const url = new URL(qrText);

    // UF via hostname
    const ufMatch = url.hostname.match(/\.(\w{2})\.gov\.br/i)
                 ?? url.hostname.match(/sefaz\.(\w{2})\./i)
                 ?? url.hostname.match(/nfce\.(\w{2})\./i);
    if (ufMatch) result.uf = ufMatch[1].toUpperCase();

    // Formato ?p=CHAVE|VERSAO|...
    const pParam = url.searchParams.get('p');
    if (pParam) {
      const key = pParam.split('|')[0]?.replace(/\D/g, '');
      if (key?.length === 44) result.accessKey = key;
    }

    // Formato alternativo ?chNFe=CHAVE
    const chNFe = url.searchParams.get('chNFe');
    if (chNFe?.replace(/\D/g, '').length === 44) {
      result.accessKey = chNFe.replace(/\D/g, '');
    }
  } catch { /* URL inválida — retorna resultado parcial sem travar */ }
  return result;
}

/**
 * Gera o trecho de contexto para injetar no prompt do Gemini.
 * Envia apenas informações estruturadas cruciais para otimizar tokens.
 */
export function buildQRContext(nfce: NFCeData): string {
  if (!nfce.accessKey) return '';
  const parts = [
    'QR Code da NFC-e detectado nesta imagem.',
    nfce.uf ? `Estado do emitente: ${nfce.uf}.` : '',
    `Chave de acesso: ${nfce.accessKey}.`,
    'Use esses dados para confirmar o estado do estabelecimento e validar a data da nota.',
  ];
  return parts.filter(Boolean).join(' ');
}
